module.exports = ".ssf-nav-bar__item {\n  display: inline-block;\n  padding: 0.8rem 1rem;\n  margin-right: -0.3rem; }\n  .ssf-nav-bar__item:first-of-type {\n    margin-left: -1rem; }\n\n.ssf-nav-bar__item_enabled {\n  color: #FFFFFF;\n  text-decoration: none; }\n  .ssf-nav-bar__item_enabled:hover, .ssf-nav-bar__item_enabled.active {\n    background-color: #2B2E5F;\n    text-decoration: none; }\n\n.ssf-nav-bar__item_disabled {\n  color: #D3D3D3;\n  text-decoration: none;\n  cursor: not-allowed; }\n  .ssf-nav-bar__item_disabled:hover {\n    text-decoration: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-navigation/app-navigation.component.scss
// module id = 789
// module chunks = 3